<template>
    <v-app id="inspire">
        <Navigation></Navigation>
        <AppBar
                :title="pageTitle"
                :actions="appBarActions"
        />
        <v-content>
            <v-container fluid>
                <v-row justify="center">
                    <v-col md="8" lg="6">

                        <v-form
                                v-model="valid"
                                ref="form"
                                lazy-validation
                                @submit.prevent="onSubmit"
                                @keyup.native.enter="onSubmit"
                        >
                            <v-card>
                                <v-card-title>Add User</v-card-title>
                                <v-card-text>
                                    <v-text-field
                                            v-model="email"
                                            :rules="rules.emailRules"
                                            label="Email"
                                            required
                                            :disabled="loading"
                                    ></v-text-field>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                            color="primary"
                                            :loading="loading"
                                            :disabled="loading"
                                            type="submit"
                                            text
                                    >
                                        Add User
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>

                    </v-col>
                </v-row>
            </v-container>
        </v-content>

        <v-snackbar
                v-model="snackbarShow"
                top
                right
                :timeout="4000"
                :color="snackbarColor"
        >
            {{ snackbarText }}
            <v-btn
                    x-small
                    text
                    fab
                    @click="snackbarShow = false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-snackbar>

    </v-app>
</template>
<script>
    export default {
        name: "UserAdd",
        props: {
            pageTitle: {
                type: String,
                default: 'Add User'
            }
        },
        data(){
            return {
                valid: false,
                loading: false,
                appBarActions: [
                    {
                        title: "Users",
                        icon: 'mdi-apps',
                        color: 'grey darken-2',
                        to: {  name: 'users' }
                    },
                ],

                rules: {
                    emailRules: [
                        (v) => !!v || 'Email is required',
                        (v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,6})+$/.test(v) || 'Email must be valid'
                    ],
                },
                snackbarColor: 'success',
                snackbarShow: false,
                snackbarText: '',

                email: '',

            }
        },
        created(){
        },
        methods:{

            setAlert( color, text ) {
                this.snackbarColor = color;
                this.snackbarText  = text;
                this.snackbarShow  = true;
            },

            onSubmit: function () {
                if( this.$refs.form.validate() ) {
                    this.submit();
                }
            },

            submit () {
                this.loading = true;
                this.axios.post('user/add', JSON.stringify( {
                    email : this.email,
                } ) ).then((response)=> {

                    const params = response.data;

                    if( params.status === 'success'){
                        this.setAlert('success', params.message );
                        this.email = '';
                    } else {
                        this.setAlert('error', params.message );
                    }
                    this.loading = false;
                }).catch(()=>{

                    this.setAlert('error', 'Data has not been received');
                    this.loading = false;
                });;
            },
        }
    }
</script>